"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartPreviewRebuild = void 0;
const enums_1 = require("../../enums");
const pushToDataLayer_1 = require("../pushToDataLayer");
function trackCartPreviewRebuild(eventLabel) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: 'Rebuild',
        eventLabel,
    });
}
exports.trackCartPreviewRebuild = trackCartPreviewRebuild;
//# sourceMappingURL=trackCartPreviewRebuild.js.map